module.exports = __webpack_public_path__ + "static/media/country_sd.0fad7ed0.webp";